const defaultConfig = Object.entries(import.meta.env).reduce(
  (conf, [key, value]) => {
    if (key.startsWith('VITE_')) {
      conf[key.replace('VITE_', '')] = value;
    }
    return conf;
  },
  {
    DASHIFI_URL: typeof window === 'undefined' ? '' : window.location.origin,
  }
);

const baseEndpointPath = 'api/v1';

const HOMEROOM = 'HOMEROOM';
const ADMINIFI = 'ADMINIFI';
const NEXT = 'NEXT';

const RECAPTCHA_SITE_KEY = '6LczDRcgAAAAAIUplF1A-kG0yoe2shhLnlRJnm2i';
const RECAPTCHA_V2_SITE_KEY = '6Le0ERcgAAAAAIkC3rNmFooVNFWmA15UbPArv191';

const defalutRecaptchaConfig = {
  siteKeyV3: RECAPTCHA_SITE_KEY,
  siteKeyV2: RECAPTCHA_V2_SITE_KEY,
  paramNameV3: 'g-recaptcha-response-data',
  actionNameV3: 'registration',
  paramNameV2: 'g-recaptcha-response',
};

const getAuthApp = app => {
  let url = defaultConfig.ADMINIFI_URL;
  let clientId = defaultConfig.ADMINIFI_CLIENT_ID;
  let redirectUri = `${window.location.origin}/callback`;
  let headerLogoLinks = {};

  if (app === HOMEROOM) {
    url = defaultConfig.HOMEROOM_PLATFORM_URL;
    clientId = defaultConfig.HOMEROOM_CLIENT_ID;
    redirectUri = `${window.location.origin}/callback-homeroom`;
    headerLogoLinks = {
      student: '/k12student',
    };
  }

  if (app === NEXT) {
    url = defaultConfig.NEXT_URL;
    clientId = defaultConfig.NEXT_CLIENT_ID;
    redirectUri = `${window.location.origin}/callback-next`;
  }

  return { url, clientId, redirectUri, headerLogoLinks };
};

const createEndpointPath = (base, version = 'v1') => `${base}/api/${version}`;

const apiBasePath = {
  EVALUFI: createEndpointPath(defaultConfig.EVALUFI_URL),
  CERTIFICATE_SERVICE: createEndpointPath(defaultConfig.CERTIFICATE_SERVICE_URL),
  CONTENT_SERVICE: createEndpointPath(defaultConfig.CONTENT_SERVICE_URL),
  COMPLIANCE: createEndpointPath(defaultConfig.COMPLIANCE_URL),
  ADMINIFI: createEndpointPath(defaultConfig.ADMINIFI_URL),
  HOMEROOM: createEndpointPath(defaultConfig.HOMEROOM_PLATFORM_URL, 'v3'),
  HOMEROOM_PLATFORM: defaultConfig.HOMEROOM_PLATFORM_URL,
  HOMEROOM_ADMIN: defaultConfig.HOMEROOM_ADMIN_URL,
  NOTIFI: createEndpointPath(defaultConfig.NOTIFI_URL),
  QUALIFI: createEndpointPath(defaultConfig.QUALIFI_URL),
};

const config = {
  ...defaultConfig,
  defalutRecaptchaConfig,
  apiBasePath,
  baseEndpointPath,
  getAuthApp,
  HOMEROOM,
  ADMINIFI,
  NEXT,
};

export default config;
export { defaultConfig };
